import { useTranslate } from "@avinet/adaptive-ui-translate";
import "./Header.scss";

interface HeaderProps {
  btnVisible?: boolean;
  btnLabel?: string;
  onClick?: () => void;
}

export function Header({ btnVisible, btnLabel, onClick }: HeaderProps) {
  const t = useTranslate("Main");

  return (
    <header className="main-header" id="top">
      <div className="aui-row align-center display-data">
        <div className="aui-column align-left">
          <h1>{t("title")}</h1>
          <p>{t("description")}</p>
        </div>
        <div className="aui-grow" />
        {btnVisible && (
          <button onClick={onClick} className="btn-link primary">
            {btnLabel || t("logout")}
          </button>
        )}
      </div>
      <hr />
    </header>
  );
}
